import { createSlice } from "@reduxjs/toolkit";
import { updateProfileApi } from "../../Services/updateProfile/updateProfileApi";

const updateProfileApiSlice = createSlice({
  name: "profileUpdate",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(updateProfileApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfileApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateProfileApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default updateProfileApiSlice.reducer;
